module.exports = __webpack_public_path__ + "static/media/21.3b33263f.JPG";